/**
 * Implements big trades page placeholder
 */
import Skeleton from 'react-loading-skeleton';

const NewPairsTableMobilePlaceholder = () => {
  return <Skeleton height={202} width='calc(var(--width) - 24px)' count={3} />;
};

export default NewPairsTableMobilePlaceholder;
